<script setup lang="ts">
import MaintenanceReportSearchBar from './MaintenanceReportSearchBar.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col px-2 lg:px-8">
    <div class="mb-4 flex max-w-lg flex-col">
      <h1 class="pb-1 text-left text-title-md2 font-semibold text-black">
        {{ t('maintenance_report.header.title') }}
      </h1>
      <p class="max-w-prose text-left font-medium">
        {{ t('maintenance_report.header.subtitle') }}
      </p>
    </div>
    <MaintenanceReportSearchBar />
  </div>
</template>
